"use client";

import React, { createContext, useContext, useState } from "react";
import { useI18n } from "@/lib/i18n/hook";

const currencies = [
  { code: "JPY", symbol: "¥", translationKey: "common.currencies.jpy" },
  { code: "USD", symbol: "$", translationKey: "common.currencies.usd" },
  { code: "EUR", symbol: "€", translationKey: "common.currencies.eur" },
  { code: "GBP", symbol: "£", translationKey: "common.currencies.gbp" },
  { code: "AUD", symbol: "A$", translationKey: "common.currencies.aud" },
  { code: "CAD", symbol: "C$", translationKey: "common.currencies.cad" },
  { code: "CHF", symbol: "Fr", translationKey: "common.currencies.chf" },
  { code: "CNY", symbol: "¥", translationKey: "common.currencies.cny" },
  { code: "HKD", symbol: "HK$", translationKey: "common.currencies.hkd" },
  { code: "SGD", symbol: "S$", translationKey: "common.currencies.sgd" },
];

export const getCurrencySymbol = (code: string) => {
  return currencies.find((c) => c.code === code)?.symbol || "¥";
};

interface CurrencyContextType {
  currency: string;
  symbol: string;
  currencies: typeof currencies;
  setCurrency: (currency: string) => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined
);

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const [currency, setCurrency] = useState("JPY");

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        symbol: getCurrencySymbol(currency),
        currencies,
        setCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}
